
<div>
  <div class="modal-header">
    <h3 class="modal-title">{{reportName}}</h3>
    <button type="button" class="btn-close" (click)="cancel()" aria-hidden="true"></button>
    <!--<alert ng-if="showAlertMessage" *ngFor="alert in alerts" type="{{alert.type}}" close="closeAlert()">{{alert.msg}}</alert>-->    
  </div>
  <div class="modal-body">    
    <div *ngIf="showAlertMessage">
      <nbc-modal-alert></nbc-modal-alert>
    </div>
    <div class="grid-table">
      <!--<span us-spinner spinner-key="exportSpinner"></span>-->
      <!--Contact-->
      <div class="grid-content-row" *ngIf="showContactRowAll">
        <div class="grid-col report-name">
          Contact
        </div>
        <div class="grid-col input-info">
          All
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-pencil" (click)="editRow('ContactRow')"></i></a>
        </div>
      </div>
      <div class="grid-content-row highlight" *ngIf="showContactEditRow">
        <div class="grid-col report-name">
          Contact
        </div>
        <div class="grid-col  input-info">
          <!--<input class="form-control contact-search" type="text" appInputRestriction="restrictChars" [(ngModel)]="transactionSummaryquery.contact" name="contactSearch" />-->
          <!--ng-focus="initAutocompleteContact()"-->
          <input [(ngModel)]="transactionSummaryquery.contact"
                 appInputRestriction="restrictChars"
                 name="contactSearch"
                 [typeahead]="contactNameObservable$"
                 [typeaheadAsync]="true"
                 [typeaheadOptionsLimit]="10"
                 [isAnimated]="true"
                 [typeaheadWaitMs]="200"
                 [typeaheadMinLength]="5"
                 class="form-control"
                 typeaheadOptionField="fullName"
                 [typeaheadItemTemplate]="customItemTemplate"
                 (typeaheadOnSelect)="onContactNameValueSelected($event)">
          <ng-template #customItemTemplate let-model="item" let-index="index">
            <strong>
              {{model.firstName ? model.firstName :model.code }}  {{model.contactMiddleName? model.contactMiddleName :""}} {{model.lastName? model.lastName :""}}{{model.contactNameNote? ", " + model.contactNameNote:""}}
            </strong>
            <br />
            <font size="2px">
              <small>
                <strong>Business Sub-segment:</strong> {{model.subBusSegment ? model.subBusSegment :'' }} <br />
                <strong>City:</strong>  {{model.city ? model.city:'' }}
                <strong>State:</strong> {{model.state ? model.state:'' }}
              </small>
            </font>
          </ng-template>
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-check" (click)="confirmSelection('ContactRow')"></i></a>
        </div>
      </div>
      <div class="grid-content-row" *ngIf="showContactTagRow">
        <div class="grid-col report-name">
          Contact
        </div>
        <div class="grid-col input-info">
          <div class="col-md-12">
            <span class="filter-tag">{{transactionSummaryquery.contact}} <a><i class="fa fa-times-circle" (click)="removeDateTag('ContactRow')"></i></a></span>
          </div>
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-pencil" (click)="editRow('ContactRow')"></i></a>
        </div>
      </div>

      <!--Date Worked-->
      <div class="grid-content-row" *ngIf="showDateRangeRowAll">
        <div class="grid-col report-name">
          Date Worked
        </div>
        <div class="grid-col input-info">
          All
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-pencil" (click)="editRow('DateRangeRow')"></i></a>
        </div>
      </div>
      <div class="grid-content-row highlight" *ngIf="showDateRangeEditRow">
        <div class="grid-col report-name">
          Date Worked
        </div>
        <div class="grid-col input-info input-info">
          <div class="input-group input-group-set max-input" dropdown is-open="rangeOfChangeDateFilter" on-toggle="onToggleDateRangeDatepicker()">
            <span class="input-group-text" dropdown-toggle><i class="fa fa-calendar"></i></span>
            <!--<input name="dateRange" class="form-control dropdown-toggle" dropdown-toggle readonly="readonly" value="{{transactionSummaryquery.dateRangeStartDate?(transactionSummaryquery.dateRangeStartDate|date) + ' -':'Select Date Range'}} {{(transactionSummaryquery.dateRangeEndDate|date)||''}}" />-->
            <input type="text"
                   placeholder="Select Date Range"
                   class="form-control"
                   bsDaterangepicker
                   readonly
                   style="cursor:pointer;"
                   [(ngModel)]="bsInlineRangeValue"
                   #drp="bsDaterangepicker"
                   (bsValueChange)="onToggleFilterDatepicker($event)"
                   [bsConfig]="{ isAnimated: true,rangeInputFormat : 'MMM D, YYYY', dateInputFormat: 'MMM D, YYYY',customTodayClass:'custom-today-class', showWeekNumbers: false}">
            <!--<div class="dropdown-menu" (click)="openDateRangeDatepicker($event)">
          <div date-range start="transactionSummaryquery.dateRangeStartDate" end="transactionSummaryquery.dateRangeEndDate"></div>
        </div>-->
          </div>
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-check" (click)="confirmSelection('DateRangeRow')"></i></a>
        </div>
      </div>
      <div class="grid-content-row" *ngIf="showDateRangeTagRow">
        <div class="grid-col report-name">
          Date Worked
        </div>
        <div class="grid-col input-info">
          <div class="col-md-12">
            <span class="filter-tag">{{transactionSummaryquery.dateRangeStartDate | date:'MM/dd/yyyy'}}-{{transactionSummaryquery.dateRangeEndDate | date:'MM/dd/yyyy'}} <a><i class="fa fa-times-circle" (click)="removeDateTag('DateRangeRow')"></i></a></span>
          </div>
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-pencil" (click)="editRow('DateRangeRow')"></i></a>
        </div>
      </div>
      <!--DayTypes(s)-->
      <div class="grid-content-row" *ngIf="showDayTypeRowAll">
        <div class="grid-col report-name">
          Day Type
        </div>
        <div class="grid-col input-info">
          All
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-pencil" (click)="editRow('DayTypeRow')"></i></a>
        </div>
      </div>
      <div class="grid-content-row highlight" *ngIf="showDayTypeEditRow">
        <div class="grid-col report-name">
          Day Type
        </div>
        <div class="grid-col input-info">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <div>
                  <nbc-multi-select name="multiselect" [source]="daytypes"
                                    value="id" display="description"
                                    [(selectedValues)]="selectedDayType"
                                    [placeholder]="'Select'"
                                    (nbcOnOptionSelect)="onDayTypeSelect($event)"></nbc-multi-select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-check" (click)="confirmSelection('DayTypeRow')"></i></a>
        </div>
      </div>
      <div class="grid-content-row" *ngIf="showDayTypeTagRow">
        <div class="grid-col report-name">
          Day Type
        </div>
        <div class="grid-col input-info">
          <div class="col-md-12" *ngFor="let daytype of selectedDayType">
            <span class="filter-tag">{{daytype.description}} <a><i class="fa fa-times-circle" (click)="removeTag(daytype,'DayTypeRow')"></i></a></span>
          </div>
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-pencil" (click)="editRow('DayTypeRow')"></i></a>
        </div>
      </div>
      <!--Event/Show-->
      <div class="grid-content-row" *ngIf="showEventShowRowAll">
        <div class="grid-col report-name">
          Event/Show
        </div>
        <div class="grid-col input-info">
          All
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-pencil" (click)="editRow('EventShowRow')"></i></a>
        </div>
      </div>
      <div class="grid-content-row highlight" *ngIf="showEventShowEditRow">
        <div class="grid-col report-name">
          Event/Show
        </div>
        <div class="grid-col input-info">
          <input class="form-control" type="text" appInputRestriction="restrictChars" placeholder="Event/Show"
                 [(ngModel)]="transactionSummaryquery.eventShow" />
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-check" (click)="confirmSelection('EventShowRow')"></i></a>
        </div>
      </div>
      <div class="grid-content-row" *ngIf="showEventShowTagRow">
        <div class="grid-col report-name">
          Event/Show
        </div>
        <div class="grid-col input-info">
          <div class="col-lg-12">
            <span class="filter-tag" style="word-wrap: break-word;">{{transactionSummaryquery.eventShow}} <a><i class="fa fa-times-circle" (click)="removeDateTag('EventShowRow')"></i></a></span>
          </div>
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-pencil" (click)="editRow('EventShowRow')"></i></a>
        </div>
      </div>
      <!--Network(s)-->
      <div class="grid-content-row" *ngIf="showNetworksRowAll">
        <div class="grid-col report-name">
          Network(s)
        </div>
        <div class="grid-col input-info">
          All
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-pencil" (click)="editRow('NetworksRow')"></i></a>
        </div>
      </div>
      <div class="grid-content-row highlight" *ngIf="showNetworksEditRow">
        <div class="grid-col report-name">
          Network(s)
        </div>
        <div class="grid-col input-info">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <!--<div [ngClass]="{'has-error':addSalaryCodeForm.rateCard.$invalid && submitted || requireRateCard}">-->
                <div>
                  <!--<select name="role"
                      class="dropdown-toggle form-control"
                      [(ngModel)]="selectedNetwork"
                      style="height:35px;">
                <option [ngValue]="null">Select Network</option>
                <option *ngFor="let n of networks" [ngValue]="n">{{n.description}}</option>
              </select>-->
                  <!--<div nbc-multi-select-dropdown="" options="transactionLookup.networks" selected-model="selectedNetwork" translation-texts="id" extra-settings="eventselectionsettings" checkboxes="true" required></div>-->
                  <nbc-multi-select name="multiselect" [source]="networks" value="id" display="description" [(selectedValues)]="selectedNetwork" [placeholder]="'Select'"
                                    (nbcOnOptionSelect)="onItemSelect($event)"></nbc-multi-select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-check" (click)="confirmSelection('NetworksRow')"></i></a>
        </div>
      </div>
      <div class="grid-content-row" *ngIf="showNetworksTagRow">
        <div class="grid-col report-name">
          Network(s)
        </div>
        <div class="grid-col input-info">
          <div class="col-md-12" *ngFor="let network of selectedNetwork">
            <span class="filter-tag">{{network.description}} <a><i class="fa fa-times-circle" (click)="removeTag(network,'NetworksRow')"></i></a></span>
          </div>
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-pencil" (click)="editRow('NetworksRow')"></i></a>
        </div>
      </div>
      <!--Sport(s)-->
      <div class="grid-content-row" *ngIf="showSportsRowAll">
        <div class="grid-col report-name">
          Sport(s)
        </div>
        <div class="grid-col input-info">
          All
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-pencil" (click)="editRow('SportsRow')"></i></a>
        </div>
      </div>
      <div class="grid-content-row highlight" *ngIf="showSportsEditRow">
        <div class="grid-col report-name">
          Sport(s)
        </div>
        <div class="grid-col input-info">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <nbc-multi-select name="multiselect" [source]="sport" value="id" display="description" [(selectedValues)]="selectedSport" [placeholder]="'Select'"
                                  (nbcOnOptionSelect)="onItemSelectSport($event)"></nbc-multi-select>
              </div>
            </div>
          </div>
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-check" (click)="confirmSelection('SportsRow')"></i></a>
        </div>
      </div>
      <div class="grid-content-row" *ngIf="showSportsTagRow">
        <div class="grid-col report-name">
          Sport(s)
        </div>
        <div class="grid-col input-info">
          <div class="col-md-12" *ngFor="let sport of selectedSport">
            <span class="filter-tag">{{sport.description}} <a><i class="fa fa-times-circle" (click)="removeTag(sport,'SportsRow')"></i></a></span>
          </div>
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-pencil" (click)="editRow('SportsRow')"></i></a>
        </div>
      </div>
      <!--WBSE/CostCenter-->
      <div class="grid-content-row" *ngIf="showWbseRowAll">
        <div class="grid-col report-name">
          WBSE/CostCenter
        </div>
        <div class="grid-col input-info">
          All
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-pencil" (click)="editRow('WbseRow')"></i></a>
        </div>
      </div>
      <div class="grid-content-row highlight" *ngIf="showWbseEditRow">
        <div class="grid-col report-name">
          WBSE/CostCenter
        </div>
        <div class="grid-col input-info">
          <input class="form-control" type="text" appInputRestriction="restrictChars" placeholder="WBSE/Cost Center"
                 [(ngModel)]="transactionSummaryquery.wbseCostCenter" />
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-check" (click)="confirmSelection('WbseRow')"></i></a>
        </div>
      </div>
      <div class="grid-content-row" *ngIf="showWbseTagRow">
        <div class="grid-col report-name">
          WBSE/CostCenter
        </div>
        <div class="grid-col input-info">
          <div class="col-md-12">
            <span class="filter-tag">{{transactionSummaryquery.wbseCostCenter}} <a><i class="fa fa-times-circle" (click)="removeDateTag('WbseRow')"></i></a></span>
          </div>
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-pencil" (click)="editRow('WbseRow')"></i></a>
        </div>
      </div>
      <!--GL Account-->
      <div class="grid-content-row" *ngIf="showGlAccountRowAll">
        <div class="grid-col report-name">
          GL Account
        </div>
        <div class="grid-col input-info">
          All
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-pencil" (click)="editRow('GlaccountRow')"></i></a>
        </div>
      </div>
      <div class="grid-content-row" *ngIf="showGlAccountEditRow">
        <div class="grid-col report-name">
          GL Account
        </div>
        <!--<div class="grid-col" tags-input
    [(ngModel)]="transactionSummaryquery.glAccount"
    placeholder="Gl Account Search"
    replace-spaces-with-dashes="false">-->
        <!--<div auto-complete source="loadGlAccount($query)" min-length="5"></div>
    </div>-->
        <div class="grid-col input-info">
          <!--<input class="form-control gl-account-typeaheadtransaction numbers-only" type="text"
      maxlength="9"
      [(ngModel)]="transactionSummaryquery.glAccount"
      name="glAccount" />-->
          <!--ng-focus="initAutocompleteglAccount()"-->

          <input [(ngModel)]="transactionSummaryquery.glAccount"
                 appInputRestriction="numberOnly"
                 name="glAccountGU"
                 placeholder="GL Account"
                 [typeahead]="glAccountObservable$"
                 [typeaheadAsync]="true"
                 [typeaheadOptionsLimit]="10"
                 [isAnimated]="true"
                 [typeaheadWaitMs]="200"
                 [typeaheadMinLength]="5"
                 maxlength="9"
                 class="form-control"
                 (typeaheadOnSelect)="onGLAccountValueSelected($event)">

        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-check" (click)="confirmSelection('GlaccountRow')"></i></a>
        </div>
      </div>
      <div class="grid-content-row" *ngIf="showGlAccountTagRow">
        <div class="grid-col report-name">
          GL Account
        </div>
        <div class="grid-col input-info">
          <div class="col-md-12">
            <span class="filter-tag">{{transactionSummaryquery.glAccount}} <a><i class="fa fa-times-circle" (click)="removeDateTag('GlaccountRow')"></i></a></span>
          </div>
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-pencil" (click)="editRow('GlaccountRow')"></i></a>
        </div>
      </div>
      <!--Employee Type-->
      <div class="grid-content-row" *ngIf="showEmployeeTypeRowAll">
        <div class="grid-col report-name">
          Employee Type
        </div>
        <div class="grid-col input-info">
          All
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-pencil" (click)="editRow('EmployeeTypeRow')"></i></a>
        </div>
      </div>
      <div class="grid-content-row highlight" *ngIf="showEmployeeTypeEditRow">
        <div class="grid-col report-name">
          Employee Type
        </div>
        <div class="grid-col input-info">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <nbc-multi-select name="multiselect" [source]="employeetypes" value="id" display="description" [(selectedValues)]="selectedEmployeeType" [placeholder]="'Select'"
                                  (nbcOnOptionSelect)="onItemSelectEmp($event)"></nbc-multi-select>
              </div>
            </div>
          </div>
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-check" (click)="confirmSelection('EmployeeTypeRow')"></i></a>
        </div>
      </div>
      <div class="grid-content-row" *ngIf="showEmployeeTypeTagRow">
        <div class="grid-col report-name">
          Employee Type
        </div>
        <div class="grid-col input-info">
          <div class="col-md-12" *ngFor="let employeeType of selectedEmployeeType">
            <span class="filter-tag">{{employeeType.description}} <a><i class="fa fa-times-circle" (click)="removeTag(employeeType,'EmployeeTypeRow')"></i></a></span>
          </div>
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-pencil" (click)="editRow('EmployeeTypeRow')"></i></a>
        </div>
      </div>
      <!--Union Code-->
      <div class="grid-content-row" *ngIf="showUnionCodeRowAll">
        <div class="grid-col report-name">
          Union Code
        </div>
        <div class="grid-col input-info">
          All
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-pencil" (click)="editRow('UnionCodeRow')"></i></a>
        </div>
      </div>
      <div class="grid-content-row highlight" *ngIf="showUnionCodeEditRow">
        <div class="grid-col report-name">
          Union Code
        </div>
        <div class="grid-col input-info">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <nbc-multi-select name="multiselect" [source]="unioncodes" value="id" display="description" [(selectedValues)]="selectedUnionCode" [placeholder]="'Select'"
                                  (nbcOnOptionSelect)="onItemSelectUnionCode($event)"></nbc-multi-select>
              </div>
            </div>
          </div>
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-check" (click)="confirmSelection('UnionCodeRow')"></i></a>
        </div>
      </div>
      <div class="grid-content-row" *ngIf="showUnionCodeTagRow">
        <div class="grid-col report-name">
          Union Code
        </div>
        <div class="grid-col input-info">
          <div class="col-md-12" *ngFor="let unionCode of selectedUnionCode">
            <span class="filter-tag">{{unionCode.description}} <a><i class="fa fa-times-circle" (click)="removeTag(unionCode,'UnionCodeRow')"></i></a></span>
          </div>
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-pencil" (click)="editRow('UnionCodeRow')"></i></a>
        </div>
      </div>
      <!--Business Unit(s)-->
      <div class="grid-content-row" *ngIf="showBURowAll">
        <div class="grid-col report-name">
          Business Units
        </div>
        <div class="grid-col input-info">
          All
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-pencil" (click)="editRow('BURow')"></i></a>
        </div>
      </div>
      <div class="grid-content-row highlight" *ngIf="showBUEditRow">
        <div class="grid-col report-name">
          Business Units
        </div>
        <div class="grid-col input-info">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <!--<div [ngClass]="{'has-error':addSalaryCodeForm.rateCard.$invalid && submitted || requireRateCard}">-->
                <div>
                  <!--<select name="role"
                      class="dropdown-toggle form-control"
                      [(ngModel)]="selectedNetwork"
                      style="height:35px;">
                <option [ngValue]="null">Select Network</option>
                <option *ngFor="let n of networks" [ngValue]="n">{{n.description}}</option>
              </select>-->
                  <!--<div nbc-multi-select-dropdown="" options="transactionLookup.networks" selected-model="selectedNetwork" translation-texts="id" extra-settings="eventselectionsettings" checkboxes="true" required></div>-->
                  <nbc-multi-select name="multiselect" [source]="businessUnits" value="id" display="displayName" [(selectedValues)]="selectedBU" [placeholder]="'Select'"
                                    (nbcOnOptionSelect)="onItemSelectBU($event)"></nbc-multi-select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-check" (click)="confirmSelection('BURow')"></i></a>
        </div>
      </div>
      <div class="grid-content-row" *ngIf="showBUTagRow">
        <div class="grid-col report-name">
          Business Units
        </div>
        <div class="grid-col input-info" *ngIf="selectedBU">
          <div class="col-md-12" *ngFor="let bu of selectedBU">
            <span class="filter-tag">{{bu.displayName}} <a><i class="fa fa-times-circle" (click)="removeTag(bu,'BURow')"></i></a></span>
          </div>
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-pencil" (click)="editRow('BURow')"></i></a>
        </div>
      </div>
      <!--Processed Date Range-->
      <div class="grid-content-row" *ngIf="showProcessedDateRangeRowAll">
        <div class="grid-col report-name">
          Processed Date Range
        </div>
        <div class="grid-col input-info">
          All
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-pencil" (click)="editRow('ProcessedDateRangeRow')"></i></a>
        </div>
      </div>
      <div class="grid-content-row highlight" *ngIf="showProcessedDateRangeEditRow">
        <div class="grid-col report-name">
          Processed Date Range
        </div>
        <div class="grid-col input-info input-info">
          <div class="input-group input-group-set max-input " dropdown is-open="dateRangeFilter" on-toggle="onToggleDateRangeDatepicker()">
            <span class="input-group-text" dropdown-toggle><i class="fa fa-calendar"></i></span>
            <input type="text"
                   placeholder="Select Date Range"
                   placement="top"
                   class="form-control dropdown-toggle"
                   style="cursor:pointer;"
                   bsDaterangepicker
                   readonly
                   [(ngModel)]="bsInlineRangeValueP"
                   #drp="bsDaterangepicker"
                   (bsValueChange)="onToggleProcessedFilterDatepicker($event)"
                   [bsConfig]="{ isAnimated: true,rangeInputFormat : 'MMM D, YYYY', dateInputFormat: 'MMM D, YYYY',customTodayClass:'custom-today-class', showWeekNumbers: false}">
            <!--<input name="processDate" class="form-control dropdown-toggle" dropdown-toggle readonly="readonly" value="{{transactionSummaryquery.processDateRangeStartDate?(transactionSummaryquery.processDateRangeStartDate|date) + ' -':'Select Date Range'}} {{(transactionSummaryquery.processDateRangeEndDate|date)||''}}" />-->
            <!--<div class="dropdown-menu" (click)="openDateRangeDatepicker($event)">
          <div date-range start="transactionSummaryquery.processDateRangeStartDate" end="transactionSummaryquery.processDateRangeEndDate"></div>
        </div>-->
          </div>
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-check" (click)="confirmSelection('ProcessedDateRangeRow')"></i></a>
        </div>
      </div>
      <div class="grid-content-row" *ngIf="showProcessedDateRangeTagRow">
        <div class="grid-col report-name">
          Processed Date Range
        </div>
        <div class="grid-col input-info">
          <div class="col-md-12">
            <span class="filter-tag">{{transactionSummaryquery.processDateRangeStartDate | date:'MM/dd/yyyy'}}-{{transactionSummaryquery.processDateRangeEndDate | date:'MM/dd/yyyy'}} <a><i class="fa fa-times-circle" (click)="removeDateTag('ProcessedDateRangeRow')"></i></a></span>
          </div>
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-pencil" (click)="editRow('ProcessedDateRangeRow')"></i></a>
        </div>
      </div>


      <!--Aftra?-->
      <div class="grid-content-row" *ngIf="showAftraRowAll">
        <div class="grid-col report-name">
          Aftra?
        </div>
        <div class="grid-col input-info">
          All
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-pencil" (click)="editRow('AftraRow')"></i></a>
        </div>
      </div>
      <div class="grid-content-row highlight" *ngIf="showAftraEditRow">
        <div class="grid-col report-name">
          Aftra?
        </div>
        <div class="grid-col input-info">

          <nbc-select [source]="AftraList"
                      [(model)]="selectedAftraItem"
                      nbcMismatch="input-xs"
                      display="description"
                      value="id"
                      name="aftra"
                      id="aftraId"
                      placeHolderValue="-1"
                      placeHolderDisplay="-Select-"
                      (change)="onChangeAftra(selectedAftraItem)" />

        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-check" (click)="confirmSelection('AftraRow')"></i></a>
        </div>
      </div>
      <div class="grid-content-row" *ngIf="showAftraTagRow">
        <div class="grid-col report-name">
          Aftra?
        </div>
        <div class="grid-col input-info" *ngIf="selectedAftra">
          <div class="col-md-12" *ngFor="let aft of selectedAftra">
            <span class="filter-tag">{{aft.description}} <a><i class="fa fa-times-circle" (click)="removeTag(aft,'AftraRow')"></i></a></span>
          </div>
        </div>
        <div class="grid-col report-edit">
          <a><i class="fa fa-pencil" (click)="editRow('AftraRow')"></i></a>
        </div>
      </div>



    </div>
    
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="cancel()">Cancel</button>
    <button type="button" class="btn btn-primary timesheetExportButton" [disabled]="exportDisable" (click)="exporttransactionSummaryReport(reportName)">Export</button>
    <!--(click)="exporttransactionSummaryReport(reportName)"-->
  </div>
</div>
<app-nbc-file-download *ngIf="isDownload"></app-nbc-file-download>
